export const environment = {
    apiLink: 'https://saiapi-dev.nuwatt.tech/v1/',
    socketLink: 'wss://saiapi-dev.nuwatt.tech/v1/',
    production: false,
    /**
     * Public base URL of THIS frontend (not the API). Used to build shareable deep links that
     * leave the app - agent chat links and Hyper Form links - which are then rendered as QR
     * codes or handed to someone outside the session. It must therefore be the address a
     * stranger can open in a browser, which is why it is configured per environment rather
     * than read from `window.location`: a link generated while previewing a build on one host
     * has to point at the deployed one. Always ends with a trailing slash.
     */
    appBaseUrl: 'https://sai-dev.nuwatt.tech/',
    showArabicLanguage: true,
    showCustomDefinition: true,
    showDarkMode: true,
    /** Org-admin SAI Quick Tour overlay + avatar "Start Tour". */
    showQuickTour: true,
    /** Export menu on the dashboard viewer. Off in production until the exports are ready for customers. */
    showDashboardExport: true,
    appVersion: require('../../package.json').version
};
